import * as React from 'react';
import { FC } from 'react';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import ReservationScopeService from '../../../services/ReservationScopeService';

interface ScopeDatesProps {
  scheduledEndDate: Date;
  scheduledEndReasonCode: string;
  scheduledEndDateKey: string;
  scheduledEndReasonCodeKey: string;
  disabled: boolean;
  onUpdateScheduledEndDate(event: any): void;
  onUpdateScheduledEndReasonCode(event: any): void;
}

const ScopeDates: FC<ScopeDatesProps> = (props) => {
  const [scheduledEndDate, setScheduledEndDate] = React.useState<Date>(props.scheduledEndDate);
  const [scheduledEndReasonCode, setScheduledEndReasonCode] = React.useState<string>(props.scheduledEndReasonCode);
  const [scheduleEndReasonCodes, setScheduleEndReasonCodes] = React.useState<string[]>([]);

  React.useEffect(() => {
    (async () => {
      const reasonCodes = await new ReservationScopeService().retrieveScheduledEndReasonCodes();
      setScheduleEndReasonCodes(reasonCodes);
    })();
  }, []);

  return (
    <fieldset data-testid="scope-dates-form" className={'scope-dates-form'}>
      <legend>Scope Dates</legend>
      <FormControl variant="standard" disabled={props.disabled}>
        <TextField
          type="date"
          label="Scheduled Scope End Date"
          variant="standard"
          value={scheduledEndDate}
          name={props.scheduledEndDateKey}
          data-testid="scheduled-end-date"
          disabled={props.disabled}
          InputLabelProps={{ shrink: true }}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setScheduledEndDate(event.target.value as any);
            props.onUpdateScheduledEndDate(event);
          }}
        />
      </FormControl>
      <FormControl variant="standard" disabled={props.disabled}>
        <InputLabel htmlFor="scheduled-end-reason-code">Scheduled Scope End Reason</InputLabel>
        <Select
          value={scheduledEndReasonCode}
          id="scheduled-end-reason-code"
          name={props.scheduledEndReasonCodeKey}
          data-testid="scheduled-end-reason-code"
          disabled={props.disabled}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setScheduledEndReasonCode(event.target.value);
            props.onUpdateScheduledEndReasonCode(event);
          }}
        >
          <MenuItem value="">&lt;None&gt;</MenuItem>
          {scheduleEndReasonCodes.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </fieldset>
  );
};

export default ScopeDates;
